import { enlargeSlice } from "./slice";

export const {
    // resize
    setColor,
    setDPI,
    setDimensionType,
    setHeight,
    setIsLocked,
    setPercentage,
    setShouldFillColor,
    setUnit,
    setWidth,
    setImage,
    setFillColorType,
    setUploadData
} = enlargeSlice.actions;
